import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "../../../components/Button";
import ComboBox from "../../../components/ComboBox";
import Pill from "../../../components/Pill";
import { participationListPlantStatuses } from "../../../constants/selects";
import { API_EXPORT } from "../../../helpers/api";
import fileDownload from "js-file-download";
import { setNotification } from "../../../helpers/notification";

import {
  getRegistrationGeneralStatusRequest,
  getRegistrationParticipantStatusRequest,
} from "../../../redux/actions/organizations";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import { Input, Select } from "../../../components/Inputs";
import moment from "moment";

export default function YEKGParticipation({ t }) {
  const dispatch = useDispatch();
  const selectStatus = participationListPlantStatuses(t);
  const [plantStatus, setPlantStatus] = useState();

  const [exportLoading, setExportLoading] = useState(false);

  let selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );

  const registrationGeneralStatus = useSelector(
    (state) => state.organizations.registrationGeneralStatus
  );
  const registrationParticipantStatusList = useSelector(
    (state) => state.organizations.registrationParticipantStatusList
  );

  const totalPageCount = useSelector(
    (state) => state.organizations.totalPageCount
  );

  const [activePage, setActivePage] = useState(0);
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [date, setDate] = useState(null);

  const registrationParticipantStatusColumns = [
    {
      name: t("pages.default.YEKGParticipation.table.etsoCode"),
      selector: "etsoCode",
      sortable: true,
      cell: (row) => row?.etsoCode ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.organizationID"),
      selector: "organizationId",
      sortable: true,
      cell: (row) => row?.organizationId ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      cell: (row) => row?.organizationName ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.pkCode"),
      selector: "organizationCode",
      sortable: true,
      cell: (row) => row?.organizationCode ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.licenseType"),
      selector: "licenseType",
      sortable: true,
      cell: (row) => row?.licenseType ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.yekgLisanceType"),
      selector: "yekgLicenseType",
      sortable: true,
      cell: (row) => row?.yekgLicenseType ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.yekgParticipationStatus"),
      selector: "yekgParticipantStatus",
      sortable: true,
      cell: (row) => {
        return row?.status === "ACTIVE" ? (
          <Pill type="success" label={t("ui.default.codes.ACTIVE")} />
        ) : row?.status === "PASSIVE" ? (
          <Pill type="important" label={t("ui.default.codes.PASSIVE")} />
        ) : (
          <Pill
            type="attention"
            label={t("ui.default.codes.PARTIAL_PASSIVE")}
          />
        );
      },
    },
    {
      name: t("pages.default.YEKGParticipation.table.activation"),
      selector: "registrationDate",
      sortable: true,
      cell: (row) => moment(row?.statusDate).format("DD/MM/YYYY"),
    },
  ];

  const registrationGeneralStatusColumns = [
    {
      name: t("pages.default.YEKGParticipation.table.k1GTS"),
      selector: "inChargeRetail",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.k2GTS"),
      selector: "k2",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.supplyCompany"),
      selector: "supply",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.production"),
      selector: "production",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.chargingNetworkOperator"),
      selector: "chargingNetworkOperator",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.aggregator"),
      selector: "aggregator",
      sortable: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.generalTotal"),
      selector: "generalTotal",
      sortable: true,
    },
  ];

  // Get stations for selected organization
  useEffect(() => {
    getRegistrationGeneralStatus();
    filterRegisterGeneralStatus();
  }, []);

  const getRegistrationGeneralStatus = () => {
    dispatch(getRegistrationGeneralStatusRequest({}));
  };

  const downloadCommitmentStatus = async () => {
    setExportLoading(true);
    try {
      const res = await API_EXPORT("/participant-status/export/excel", {
        date: date ? moment(date).format("DD-MM-YYYY") : null,
        organizationId: selectedOrganization
          ? (selectedOrganization.organizationId ?
             selectedOrganization.organizationId : null)
          :  null,
        participantStatus: plantStatus ?? null,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setExportLoading(false);
    }
  };

  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      getRegistrationParticipantStatusRequest({
        organizationId: selectedOrganization?.organizationId ?? null,
        // startDate: startDate ? moment(startDate).format("DD-MM-YYYY") : null,
        date: date ? moment(date).format("DD-MM-YYYY") : null,
        page: activePage,
        selector: selector,
        direction: direction,
        participantStatus: plantStatus ?? null,
      })
    );
  };

  const filterRegisterGeneralStatus = () => {
    setDate(date ? date : null);

    if (selectedOrganization && Object.keys(selectedOrganization).length === 0)
      selectedOrganization = undefined;
    let params = {
      date: date ? moment(date).format("DD-MM-YYYY") : null,
      organizationId: selectedOrganization
        ? selectedOrganization.organizationId
        : null,
      participantStatus: plantStatus ?? null,
    };

    dispatch(getRegistrationParticipantStatusRequest({ ...params }));
  };

  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.YEKGParticipation.title")}
      </h5>
      <p style={{ marginTop: "20px" }}>
        {registrationGeneralStatus &&
          registrationGeneralStatus[0]?.titleWithDate}
      </p>
      <div className="km__p--card">
        <DataTableServerSideRendering
          columns={registrationGeneralStatusColumns}
          data={registrationGeneralStatus}
          rowKey={"id"}
          // pagination
          // paginationPerPage={4}
        />
      </div>

      <div className="km__p--card">
        <div className="km__p--market-results-contracts-header">
          <p className="km__u--text_title">
            {t("pages.default.YEKGParticipation.title")}
          </p>
          <div className="km__p--market-results-contracts-header-filter">
            <Input
              type="date"
              placeholder={t("pages.default.offerOperations.table.date")}
              // min={
              //   new Date(moment(startDate).add(1, "days").format("MM-DD-YYYY"))
              // }
              value={date}
              onChange={(e) => setDate(e.target.value)}
              id="ba-history-date"
            />
            <ComboBox t={t} />
            <Select
              options={selectStatus}
              name="plantStatus"
              onChange={(e) => setPlantStatus(e.target.value)}
            />
            <Button
              label={t("ui.default.filter")}
              onClick={filterRegisterGeneralStatus}
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              suffixIcon="download"
              onClick={downloadCommitmentStatus}
              disabled={exportLoading}
              id="c-download"
            />
          </div>
        </div>
        {/* {!contractsLoading && contracts.length > 0 && ( */}
        <DataTableServerSideRendering
          columns={registrationParticipantStatusColumns}
          data={registrationParticipantStatusList}
          rowKey="id"
          sortedColumn={sortedColumn}
          setSortedColumn={setSortedColumn}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          pagination
          // rowSelection={(row) => contractSelection(row)}
          // isRowSelected={(row) => contractRowSelected(row)}
          // selectableRow
          activePage={activePage}
          totalPageCount={totalPageCount}
          handleFetchData={handleClick}
        />
        {/* )} */}
      </div>
    </>
  );
}
